import CardFilter from "./CardFilter";
import { IonCard } from "@ionic/react";
import CardInfo from "./CardInfo";
import { QueryResult } from "../hooks/useQueryExec";
import { encodeParam } from "../util/ApiHelper";
import { SelectedEquip } from "../models/equipment/Equipment";
import { useEquipmentStore } from "../store/equipment";
import { useOfflineStore } from "../store/offline-mode";

type Props = {
  filteredRows: QueryResult[];
  isSelectable?: boolean;
  onToggle?: (cardData: SelectedEquip) => void;
  hideFilter?: boolean;
  onFilter: (queryString: string) => Promise<void>;
  filterString: string;
  onQueryRowClick?: (row: QueryResult) => void;
  selectedEquipIds?: string[];
  allRows: QueryResult[];
  equipmentClick?: (arg0?: any) => void;
  equipmentChange?: boolean;
};

export default function EquipmentCards({
  filteredRows,
  allRows,
  filterString,
  onFilter,
  hideFilter,
  isSelectable,
  onQueryRowClick,
  onToggle,
  selectedEquipIds,
  equipmentChange,
  equipmentClick,
}: Props) {
  const hasData = !!allRows && allRows.length > 0;
  const isOffline = useOfflineStore((state) => state.isOffline);
  if (!hasData) return null;

  return (
    <>
      <CardFilter
        hideFilter={hideFilter}
        queryRows={allRows}
        resultsFilter={filterString}
        filterMethod={onFilter}
      />
      {filteredRows.map((row) => {
        const linkedInspections =
          useEquipmentStore
            .getState()
            .getInspectionsForEquipment(row.HeaderValue) ?? [];
        const inspectionId =
          linkedInspections.length > 1
            ? undefined
            : linkedInspections.at(0)?.InspectionId;

        let routerLink =
          !equipmentChange && !equipmentClick
            ? `/Equipment/${encodeParam(row.HeaderValue)}`
            : undefined;
        if (isOffline) {
          if (inspectionId)
            routerLink = `/Equipment/${encodeParam(
              row.HeaderValue
            )}/inspection/${inspectionId}`;
          else
            routerLink = `/Equipment/${encodeParam(
              row.HeaderValue
            )}/inspections`;
        }
        return (
          <IonCard
            key={row.HeaderRow}
            onClick={() => onQueryRowClick?.(row)}
            routerLink={routerLink}
          >
            <CardInfo
              isSelectable={isSelectable}
              isSelected={selectedEquipIds?.some((s) => s === row.HeaderValue)}
              header={row.HeaderValue}
              columns={row.Columns}
              onToggle={(id: string) => {
                onToggle?.({
                  row,
                  id,
                  columns: row.Columns,
                });
              }}
            />
          </IonCard>
        );
      })}
    </>
  );
}
